import Vue from 'vue'
import App from '@/views/App.vue'
import getRouter from "@/router"
import store from '@/store/index'
import vueHelper from "@/vueHelper"
import Textbox from "@/components/textbox"
import MobileSelectbox from "@/components/mobileSelectbox"
import MobileTextbox from "@/components/mobileTextbox"
import Datebox from "@/components/datebox"
import RichText from "@/components/richtext"
import Datebox2 from "@/components/datebox2"
import FileUpload from "@/components/fileupload"
import CheckBox from "@/components/checkbox"
import SlickGrid from "@/components/SlickGrid"
import DataFilter from "@/components/Filter"
import RadioBox from "@/components/radiobox"
import PageHeader from "@/components/PageHeader"
import PageMobileHeader from "@/components/PageMobileHeader"
import PageHeaderNoAction from "@/components/PageHeaderNoAction"
import fbtextbox from "@/components/fbtextbox"
import fbtextarea from "@/components/fbtextarea"
import fbdatebox2 from "@/components/fbdatebox2"
import fbcheckBox from "@/components/fbcheckbox"
import fbradioBox from "@/components/fbradiobox"
import fbselectbox from "@/components/fbselectbox"
import fbselectbox2 from "@/components/fbselectbox2"
import fbpreparerselectbox from "@/components/fbpreparerselectbox"
import fbfileupload from "@/components/fbfileupload"
import fbnumberbox from "@/components/fbnumberbox"
import mbcheckBox from "@/components/mbcheckbox"
import fbcheckBoxes from "@/components/fbcheckboxes"
import fbdatetimebox from "@/components/fbdatetimebox"
import fbtextdayhourbox from "@/components/fbtextdayhourbox"
import fbsignature from "@/components/fbsignature"
import fbrecaptcha from "@/components/fbrecaptcha"
import fbocrbutton from "@/components/fbocrbutton"
import msal from 'vue-msal'
import { msalMixin } from 'vue-msal';
import assetsConfig from "@/config"
import "./assets/icofont/icofont.css";
import "./assets/scss/slickgrid-theme-bootstrap.scss";
import axios from 'axios'


let installHelper = (Vue, options) => {
  Vue.prototype.$helper = vueHelper;
}


async function init() {
  assetsConfig.serverURI = config.serverURI;
  assetsConfig.serverBase = config.serverBase;

  console.log(assetsConfig.serverURI+assetsConfig.filePath);



  await vueHelper.getConfig();

  assetsConfig.sessionWarn = vueHelper.getParam("SESSION_WARNING") || assetsConfig.sessionWarn;
  assetsConfig.sessionTimeout = vueHelper.getParam("SESSION_TIMEOUT") || assetsConfig.sessionTimeout;
 
  

  console.log(assetsConfig.sessionWarn);
  Vue.config.productionTip = false

  Vue.use(installHelper);

  if(vueHelper.getParam("msal_clientid")){
    Vue.use(msal, {
      auth: {
        clientId: vueHelper.getParam("msal_clientid"),
        graphScopes: ['user.read'],
        redirectUri: vueHelper.getParam("msal_redirect"),
        postLogoutRedirectUri: vueHelper.getParam("msal_logout_redirect")
      }
    });
  }
 


  Vue.component('Textbox', Textbox)
  Vue.component('MobileTextbox', MobileTextbox)
  Vue.component('Datebox', Datebox)
  Vue.component('Datebox2', Datebox2)
  Vue.component('FileUpload', FileUpload)
  Vue.component('CheckBox', CheckBox)
  Vue.component('SlickGrid', SlickGrid)
  Vue.component('DataFilter', DataFilter)
  Vue.component('RadioBox', RadioBox)
  Vue.component('PageHeader', PageHeader)
  Vue.component('PageMobileHeader', PageMobileHeader)
  Vue.component('PageHeaderNoAction', PageHeaderNoAction)
  Vue.component('MobileSelectbox', MobileSelectbox)
  Vue.component('fbtextbox', fbtextbox)
  Vue.component('fbtextarea', fbtextarea)
  Vue.component('fbdatebox2', fbdatebox2)
  Vue.component('fbcheckbox', fbcheckBox)
  Vue.component('fbradiobox', fbradioBox)
  Vue.component('fbselectbox', fbselectbox)
  Vue.component('fbselectbox2', fbselectbox2)
  Vue.component('fbpreparerselectbox', fbpreparerselectbox)
  Vue.component('fbfileupload', fbfileupload)
  Vue.component('fbnumberbox', fbnumberbox)
  Vue.component('mbCheckBox', mbcheckBox)
  Vue.component('fbcheckboxes', fbcheckBoxes)
  Vue.component('fbdatetimebox', fbdatetimebox)
  Vue.component('fbtextdayhourbox', fbtextdayhourbox)
  Vue.component('fbsignature', fbsignature)
  Vue.component('fbrecaptcha', fbrecaptcha)
  Vue.component('fbocrbutton', fbocrbutton)
  Vue.component('RichText', RichText)

  // export const bus = new Vue();

  // let router = require('@/router');

  var mainVue = new Vue({
    el: '#app',
    mixins: [msalMixin],
    router:getRouter(),
    store,
    render: function (h) {
      return h(App)
    },
    // computed: {
    //   user() {
    //     let user = null;
    //     if (this.msal.isAuthenticated) { // Note that the dollar sign ($) is missing from this.msal
    //       user = {
    //         ...this.msal.user,
    //         profile: {}
    //       }
    //       if (this.msal.graph && this.msal.graph.profile) {
    //           user.profile = this.msal.graph.profile
    //       }
    //     }
    //     console.log(user);
    //     return user;
    //   }
    // }
  })

}


init();